import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const gammaLevelsGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX GEX Levels',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX GEX Levels@tv-basicstudies-1",
        description: "SPX GEX Levels",
        shortDescription: "SPX GEX Levels",
        format: { type: "price" },
        linkedToSeries: true,
        is_price_study: true,
        plots: [
          { id: "call_r1", type: "line" },
          { id: "call_r2", type: "line" },
          { id: "put_r1", type: "line" },
          { id: "put_r2", type: "line" }
        ],
        defaults: {
          styles: {
            call_r1: {
              linestyle: 0,
              linewidth: 1,
              transparency: 0,
              color: "#ff0000",
            },
            call_r2: {
              linestyle: 1,
              linewidth: 1,
              transparency: 0,
              color: "#ff0000",
            },
            put_r1: {
              linestyle: 0,
              linewidth: 1,
              transparency: 0,
              color: "#00ff00",
            },
            put_r2: {
              linestyle: 1,
              linewidth: 1,
              transparency: 0,
              color: "#00ff00",
            }
          },
        },
        styles: {
          call_r1: { title: "Gamma Call R1" },
          call_r2: { title: "Gamma Call R2" },
          put_r1: { title: "Gamma Put R1" },
          put_r2: { title: "Gamma Put R2" }
        },
        inputs: [],
      },
      constructor: function () {
        this._debugMode = true;

        this.init = function (ctx) {
          this._context = ctx;
        };

        this.main = function (ctx) {
          try {
            const { topOptions } = useGreeksWebsocketDataStore.getState();
            const spxOptions = topOptions.spx;

            if (!spxOptions?.length) {
              if (this._debugMode) {
                // console.log('[gammaLevelsGetter] No top options data');
              }
              return [NaN, NaN, NaN, NaN];
            }

            // Keep valid latest gamma levels. A malformed update must not replace
            // the last usable level or create a zero-valued chart line.
            const latestByKey = {};
            for (const opt of spxOptions) {
              if (opt?.greek_type !== 'gamma') continue;

              const key = `${opt.option_type}-${opt.rank}`;
              if (!['call-1', 'call-2', 'put-1', 'put-2'].includes(key)) continue;

              const rawTimestamp = opt.timestamp;
              const timestampMissing = rawTimestamp == null || rawTimestamp === '';
              const numericTimestamp = timestampMissing ? NaN : Number(rawTimestamp);
              const currentTs = timestampMissing
                ? NaN
                : Number.isFinite(numericTimestamp)
                  ? (numericTimestamp < 10_000_000_000 ? numericTimestamp * 1000 : numericTimestamp)
                  : Date.parse(rawTimestamp);
              const strikePrice = Number(opt.strike_price);
              if (
                !Number.isFinite(strikePrice)
                || strikePrice <= 0
                || (!timestampMissing && !Number.isFinite(currentTs))
              ) {
                continue;
              }

              if (
                !latestByKey[key] ||
                (Number.isFinite(currentTs) && (
                  !Number.isFinite(latestByKey[key].timestamp)
                  || currentTs > latestByKey[key].timestamp
                ))
              ) {
                latestByKey[key] = { strikePrice, timestamp: currentTs };
              }
            }

            const callR1 = latestByKey['call-1']?.strikePrice ?? NaN;
            const callR2 = latestByKey['call-2']?.strikePrice ?? NaN;
            const putR1 = latestByKey['put-1']?.strikePrice ?? NaN;
            const putR2 = latestByKey['put-2']?.strikePrice ?? NaN;

            return [callR1, callR2, putR1, putR2];
          } catch (err) {
            console.error('[gammaLevelsGetter] Error in main:', err);
            return [NaN, NaN, NaN, NaN];
          }
        };

        this.destroy = function () {
          // No cleanup needed since we're not using subscriptions
        };
      },
    },
  ]);
};







// import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';
//
// export const gammaLevelsGetter = function (PineJS) {
//  return Promise.resolve([
//    {
//      name: 'SPX GEX Levels',
//      metainfo: {
//        metainfoVersion: 53,
//        id: "SPX GEX Levels@tv-basicstudies-1",
//        description: "SPX GEX Levels",
//        shortDescription: "SPX GEX Levels",
//        format: { type: "price" },
//        linkedToSeries: true,
//        is_price_study: true,
//        plots: [
//          { id: "call_r1", type: "line" },
//          { id: "call_r2", type: "line" },
//          { id: "put_r1", type: "line" },
//          { id: "put_r2", type: "line" }
//        ],
//        defaults: {
//          styles: {
//            call_r1: {
//              linestyle: 0,
//              linewidth: 1,
//              transparency: 0,
//              color: "#FFA500",
//            },
//            call_r2: {
//              linestyle: 1,
//              linewidth: 1,
//              transparency: 0,
//              color: "#FFA500",
//            },
//            put_r1: {
//              linestyle: 0,
//              linewidth: 1,
//              transparency: 0,
//              color: "#ee2baa",
//            },
//            put_r2: {
//              linestyle: 1,
//              linewidth: 1,
//              transparency: 0,
//              color: "#ee2baa",
//            }
//          },
//        },
//        styles: {
//          call_r1: { title: "Gamma Call R1" },
//          call_r2: { title: "Gamma Call R2" },
//          put_r1: { title: "Gamma Put R1" },
//          put_r2: { title: "Gamma Put R2" }
//        },
//        inputs: [],
//      },
//      constructor: function () {
//        this._debugMode = true;
//
//        this.init = function (ctx) {
//          this._context = ctx;
//        };
//
//        this.main = function (ctx) {
//          try {
//            const { topOptions } = useGreeksWebsocketDataStore.getState();
//            const spxOptions = topOptions.spx;
//
//            if (!spxOptions?.length) {
//              if (this._debugMode) {
//                // console.log('[gammaLevelsGetter] No top options data');
//              }
//              return [NaN, NaN, NaN, NaN];
//            }
//
//            // Filter for gamma options
//            const gammaOptions = spxOptions.filter(opt => opt.greek_type === 'gamma');
//
//            // Get current levels exactly like dynamic levels
//            const callR1 = gammaOptions.find(opt => opt.option_type === 'call' && opt.rank === 1)?.strike_price || NaN;
//            const callR2 = gammaOptions.find(opt => opt.option_type === 'call' && opt.rank === 2)?.strike_price || NaN;
//            const putR1 = gammaOptions.find(opt => opt.option_type === 'put' && opt.rank === 1)?.strike_price || NaN;
//            const putR2 = gammaOptions.find(opt => opt.option_type === 'put' && opt.rank === 2)?.strike_price || NaN;
//
//
//            // Return the same level for any point in time
//            return [callR1, callR2, putR1, putR2];
//          } catch (err) {
//            console.error('[gammaLevelsGetter] Error in main:', err);
//            return [NaN, NaN, NaN, NaN];
//          }
//        };
//
//        this.destroy = function() {
//          // No cleanup needed since we're not using subscriptions
//        };
//      },
//    },
//  ]);
// };







